import styled from 'styled-components'

export const DemoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
`

export const ComponentContainer = styled.div`
  width: 100%;
`

export const PickerWrapper = styled.div`
  position: relative;
  width: 100%;
`

/** Match MUI TextField size="small" height (~40px) for consistent form fields. */
export const TextFieldInput = styled.div<{ $readOnly?: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 40px;
  height: 40px;
  box-sizing: border-box;
  background-color: ${({ $readOnly }) => ($readOnly ? '#F0F2F5' : 'white')};
  border: ${({ $readOnly }) => ($readOnly ? 'none' : '0.1px solid #ccc')} !important;
  border-radius: ${({ $readOnly }) => ($readOnly ? '8px' : '10px')};
  padding: 0 14px;
  cursor: pointer;

  & .MuiSvgIcon-root {
    font-size: 1.25rem;
  }
`

export const DateDisplay = styled.span<{ $readOnly?: boolean }>`
  margin-left: 0.5rem;
  white-space: nowrap;
  overflow-x: auto;
  font-size: 0.875rem;
  line-height: 1.25;
  color: #000000;
`
